import Vue from 'vue'
import Router from 'vue-router'
import VueLodash from 'vue-lodash'




import Main from '@/components/Main'
import MemberLogin from '@/components/Member/Login'
import MemberJoin from '@/components/Member/Join'
import MemberMyAI from '@/components/Member/MyAI'

import MemberChangePassword from '@/components/Member/ChangePassword'
import MemberFindPw from '@/components/Member/FindPw'
import MemberUpdateMyinfo from '@/components/Member/UpdateMyinfo'

import PagePrivate from '@/components/Member/private'
import PageAgree from '@/components/Member/agree'
import PageAbout from '@/components/Member/about'



import ProblemList from '@/components/Problem/List'
import ProblemView from '@/components/Problem/View'
import ProblemSearch from '@/components/Problem/Search'
import ProblemUserTest from '@/components/Problem/userTest'
import ProblemUserReport from '@/components/Problem/myReport'


import AdvisorList from '@/components/Advisor/list'
import AdvisorView from '@/components/Advisor/view'
import AdvisorSentence from '@/components/Advisor/sentence'
import AdvisorSentenceView from '@/components/Advisor/sentenceView'
import AdvisorWord from '@/components/Advisor/word'
import AdvisorGtest from '@/components/Advisor/gtest'


import BoardNotice from '@/components/Board/Notice'
import BoardQuestion from '@/components/Board/Question'

import BoardView from '@/components/Board/view'
import BoardWrite from '@/components/Board/Write'



const options = { name: 'lodash' } // customize the way you want to call it
Vue.use(VueLodash, options) // options is optional

Vue.use(Router)

export default new Router({
  scrollBehavior (to, from, savedPosition) {
	if(savedPosition) {
		//console.log(JSON.stringify(savedPosition));
		return savedPosition;
	} else {
		
		return { x: 0, y:0}
	}
	
  },
  routes: [
    {
      path: '/',
      name: 'Main',
      component:Main,
	  children: [{
		path: '/problem/search',
		name: 'ProblemSearch',
		component:ProblemSearch
		}]
	},
	{
		path: '/problem/me',
		name: 'ProblemUserTest',
		component:ProblemUserTest
	},
	{
		path: '/problem/view/:cmd/:no',
		name: 'ProblemView',
		component:ProblemView
	},
	{
		path: '/problem/myreport',
		name: 'ProblemUserReport',
		component:ProblemUserReport
	},
	{
      path: '/member/login',
      name: 'MemberLogin',
      component:MemberLogin
	},
    {
      path: '/member/join',
      name: 'MemberJoin',
      component:MemberJoin
    },
	{
      path: '/member/myAi/:cmd',
      name: 'MemberMyAI',
      component:MemberMyAI
    },
	{
      path: '/advisor/list',
      name: 'AdvisorList',
      component:AdvisorList
    },
	{
      path: '/advisor/view/:no',
      name: 'AdvisorView',
      component:AdvisorView
    },
	{
      path: '/advisor/sentence',
      name: 'AdvisorSentence',
      component:AdvisorSentence
    },
	{
      path: '/advisor/sentenceView/:no',
      name: 'AdvisorSentenceView',
      component:AdvisorSentenceView
    },
	{
      path: '/advisor/word',
      name: 'AdvisorWord',
      component:AdvisorWord
    },
	{
      path: '/advisor/gtest',
      name: 'AdvisorGtest',
      component:AdvisorGtest
    }, 
	{
      path: '/board/notice',
      name: 'BoardNotice',
      component:BoardNotice
    },
	{
      path: '/board/question',
      name: 'BoardQuestion',
      component:BoardQuestion
    },
	{
      path: '/board/view/:no',
      name: 'BoardView',
      component:BoardView
    },
	{
      path: '/board/write/:bid',
      name: 'BoardWrite',
      component:BoardWrite
    },
	{
      path: '/member/changePassword',
      name: 'MemberChangePassword',
      component:MemberChangePassword
    },
	{
      path: '/member/findPw/:cmd',
      name: 'MemberFindPw',
      component:MemberFindPw
    },
	{
      path: '/member/memberInfo',
      name: 'MemberUpdateMyinfo',
      component:MemberUpdateMyinfo
    },
	{
      path: '/page/about',
      name: 'PageAbout',
      component:PageAbout
    },
	{
      path: '/page/agree',
      name: 'PageAgree',
      component:PageAgree
    },
	{
      path: '/page/private',
      name: 'PagePrivate',
      component:PagePrivate
    },
		  
	
  ]
})

